import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Building2, ArrowRight, CheckCircle2 } from 'lucide-react';

export default function BusinessPage() {
  const { t } = useLanguage();
  const features = [
    'Multi-currency brokerage accounts (USD, EUR, KMF, KZT) used solely for client funding',
    'Mass funding of client sub-accounts via CSV (payroll-style batches within brokerage)',
    'Reusable recipient templates',
    'Brokerage invoices with legal header (License N° L16195/CFL)',
    'Dedicated onboarding and enhanced due diligence',
    'Human compliance review for every brokerage request',
  ];
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-xs uppercase tracking-widest text-[hsl(var(--brand-gold))]">Business</div>
      <h1 className="font-serif text-4xl sm:text-5xl mt-2 text-[hsl(var(--brand-navy-2))]">Corporate brokerage services</h1>
      <p className="mt-4 text-lg text-[hsl(var(--muted-foreground))] max-w-3xl">A B2B toolkit for legal entities holding a brokerage relationship with Concorde Financial. All operations are performed strictly within the scope of licensed brokerage activities.</p>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7">
          <Card className="bg-white">
            <CardContent className="p-8">
              <div className="h-12 w-12 rounded-xl bg-[hsl(var(--brand-gold))]/10 flex items-center justify-center">
                <Building2 className="h-6 w-6 text-[hsl(var(--brand-navy))]" />
              </div>
              <div className="font-serif text-2xl mt-4 text-[hsl(var(--brand-navy-2))]">Business portal</div>
              <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] leading-6">Register your legal entity, run mass payments to hundreds of recipients from a single CSV, and generate invoices with your legal reference.</p>
              <ul className="mt-6 space-y-3">
                {features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm"><CheckCircle2 className="h-4 w-4 text-[hsl(var(--brand-gold))] mt-0.5 flex-shrink-0" />{f}</li>
                ))}
              </ul>
              <div className="mt-8 flex gap-3">
                <Button asChild className="bg-[hsl(var(--brand-navy))] hover:bg-[hsl(var(--brand-navy-2))]"><Link to="/business-portal/register">Register your company <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
                <Button asChild variant="outline"><Link to="/contact">Talk to sales</Link></Button>
              </div>
            </CardContent>
          </Card>
        </div>
        <div className="lg:col-span-5 space-y-4">
          <Card className="bg-white"><CardContent className="p-6">
            <div className="font-serif text-xl text-[hsl(var(--brand-navy-2))]">Onboarding requirements</div>
            <ul className="mt-3 space-y-2 text-sm text-[hsl(var(--muted-foreground))]">
              <li>— Certificate of incorporation</li>
              <li>— Register of directors and shareholders</li>
              <li>— Proof of registered address</li>
              <li>— UBO declaration</li>
              <li>— Business plan or source of funds description</li>
            </ul>
          </CardContent></Card>
          <Card className="bg-white"><CardContent className="p-6">
            <div className="font-serif text-xl text-[hsl(var(--brand-navy-2))]">Coming soon</div>
            <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))]">B2B API for programmatic access to payments and reporting.</p>
          </CardContent></Card>
        </div>
      </div>
    </div>
  );
}
